<template>
  <div class="container d-flex justify-content-center align-items-center vh-100">
    <div class="text-center">
      <h1 class="display-1 text-danger">404</h1>
      <h2 class="mb-4">Página no encontrada</h2>
      <p class="lead">
        Lo sentimos, la página que buscas no existe o ha sido movida.
      </p>
      <button @click="goBack" class="btn btn-primary mt-3">
        Volver al inicio
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "404Page",
  methods: {
    goBack() {
      // Redirige al usuario a la página principal
      this.$router.push("/");
    },
  },
};
</script>

<style scoped>
/* Puedes personalizar estilos adicionales aquí */
body {
  background-color: #f8f9fa;
  margin: 0;
}
</style>
